import posthog from "posthog-js";

// --- Event property types ---

export type FileUploadAction = "started" | "success" | "failed";

export type FileUploadSource = "local" | "google_drive" | "docsend" | "bulk";

export type FileUploadContext = "add_deal" | "data_room" | "gap_analysis";

export type FileUploadFailureReason =
  | "missing_file_type"
  | "file_too_large"
  | "unsupported_format"
  | "server_error"
  | "network_error";

// --- Discriminated union on action ---

interface FileUploadBaseProps {
  upload_source: FileUploadSource;
  context: FileUploadContext;
  file_count: number;
  workspace_id: string;
  opportunity_application_id: string;
  user_id: string;
}

interface FileUploadStartedProps extends FileUploadBaseProps {
  action: "started";
  failure_reason?: never;
}

interface FileUploadSuccessProps extends FileUploadBaseProps {
  action: "success";
  failure_reason?: never;
}

interface FileUploadFailedProps extends FileUploadBaseProps {
  action: "failed";
  failure_reason: FileUploadFailureReason;
}

export type FileUploadEventProps =
  | FileUploadStartedProps
  | FileUploadSuccessProps
  | FileUploadFailedProps;

// --- Capture utility ---

const FILE_UPLOAD_EVENT = "file_uploaded" as const;

export function trackFileUpload(props: FileUploadEventProps): void {
  if (props.action === "failed") {
    posthog.capture(FILE_UPLOAD_EVENT, props);
  } else {
    const { failure_reason: _, ...rest } = props as unknown as FileUploadFailedProps;
    posthog.capture(FILE_UPLOAD_EVENT, rest);
  }
}
